import React from "react";
import Header from "./components/HeaderFooterLite/Header";
import Content from "./components/TermsAndConditions";
import Footer from "./components/HeaderFooterLite/Footer";

function TermsOfUse() {
  return (
    <div className="wrap-ppolicy">
      <Header />
      <Content />
      <Footer />
    </div>
  );
}

export default TermsOfUse;
